import { ICacheProvider } from "../../domain/interfaces/cache-provider.interface";
import * as Memcached from "memcached";

export class MemcacheProvider implements ICacheProvider {
	private cache: Memcached;

	constructor(memcacheUrl: string) {
		this.cache = new Memcached(memcacheUrl);
	}

	public get(key: string): Promise<object> {
		return new Promise((resolve, reject) => {

			this.cache.get(key, (error, data) => {
				error ? reject(error) : resolve(data);
			});
		});
	}

	public async has(key: string): Promise<boolean> {
		const response = await this.get(key);
		return !!response;
	}

	public set(key: string, data: object, ttl): Promise<void> {
		return new Promise((resolve, reject) => {
			this.cache.set(key, data, ttl, error => {
				error ? reject(error) : resolve();
			});
		});
	}

}
